<template>
    <div class="modal-overlay" @click="$emit('close-modal')" ref="myBtn">
        <div class="modal">
            <img width="20" height="20" :src="require(`../../assets/images/${imagePath}`)">
            <p v-if="message === 'The given data was invalid.'" class="cssMessage">{{message.slice(0,-1)}}</p>
            <p v-else class="cssMessage1">{{message}}</p>
        </div>
    </div>
</template>

<script>
    // import {onMounted} from "vue";
    // import mitt from 'mitt';
    // const emitter = mitt();
    export default {
        name:'alart-component',
        props: ['imagePath','message'],
        mounted() {
            setTimeout(()=>{
                this.$refs?.myBtn?.click()
            },2000);
        }

    }
</script>

<style scoped>

    .cssMessage{
        text-transform: capitalize;
        color: var(--text-color-in-confirmation-modal);
    }

    .cssMessage1{
        text-transform: none;
        color: var(--text-color-in-confirmation-modal);
    }

    .modal-overlay {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        background-color: #000000da;
        z-index: 9999;
    }

    .modal {
        text-align: center;
        display: flex !important;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        align-items: center;
        position: unset !important;
        background-color: var(--background-color-input-create);
        height: 160px;
        border: 1px solid #FFF;
        border-radius: 20px;
        margin: auto;
        width: 40%;
    }
    .close {
        margin: 10% 0 0 16px;
        cursor: pointer;
    }

    .close-img {
        width: 25px;
    }

    .check {
        width: 150px;
    }

    h6 {
        font-weight: 500;
        font-size: 28px;
        margin: 20px 0;
    }

    p {
        font-size: 16px;
        margin: 20px 0;
        color: #FFF;
    }

    button {
        background-color: #ac003e;
        width: 150px;
        height: 40px;
        color: white;
        font-size: 14px;
        border-radius: 16px;
        margin-top: 50px;
    }
</style>